module.exports = __webpack_public_path__ + "img/Trex_Dashboard.ff854f30.jpg";